module.exports = __webpack_public_path__ + "img/powered-by-august-hover.338084c5.svg";